import { render } from "./HousePage.vue?vue&type=template&id=b7e2a8fe&ts=true"
import script from "./HousePage.vue?vue&type=script&lang=ts"
export * from "./HousePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__